<template>
  <v-autocomplete
    v-if="options != null"
    v-model="record_id"
    :items="options"
    item-value="record_id"
    :item-text="(item) => getItemText(item)"
    :label="label"
    :outlined="outlined"
    :dense="dense"
    :clearable="clearable"
    :rules="rules"
    :readonly="readonly"
    :disabled="disabled"
    hide-details
    multiple
    @change="$emit('change', record_id)"
  ></v-autocomplete>
</template>

<script>
/*eslint-disable */
export default {
  name: "Selection",
  props: {
    value: { type: String },
    column: { type: Object },
    label: { type: String, default: "" },
    outlined: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    rules: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    language: { type: String, default: "it_IT" },
  },
  emits: ['change'],
  data() {
    return {
      options: [],
    };
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      let parameters = {};
      parameters.data = { ad_column_id: this.column.AD_Column_ID };
      parameters.idempiereRestPath = "window/getOptions";
      this.$store.dispatch("callIdempiereRest", parameters).then((response) => {
        this.options = response.data.options;
        if (
          this.options.length == 1 &&
          this.column.IsMandatory &&
          !this.record_id
        ) {
          this.record_id = this.options[0].record_id;
        }
      });
    },
    getItemText(item) {
      if(!item || !this.options || Array.isArray(item)) return "";
      return item.trl[this.language];
    },
  },
  computed: {
    record_id: {
      get() {
        let record_id = this.value;
        if (!record_id) return [];
        record_id = record_id + "";
        record_id = record_id.split(",");
        for (let index in record_id) {
          record_id[index] = parseInt(record_id[index]);
        }
        return record_id;
      },
      set(newValue) {
        if (!newValue) return "";
        this.$emit("input", newValue.join(","));
      },
    },
  },
  watch: {
    value: function () {
      //this.getOptions();
    },
  },
};
</script>

<style>
</style>